module.exports = __webpack_public_path__ + "static/media/Banquete Lai Lai_Web2025.7e352b43.png";